<template>
  <div class="app-basic-min-width default-layout app-flex-column">
    <div class="main app-flex-column">
      <div class="brand-page topfans_page">
        <div class="banner">
          <div class="content">
            <h3 class="title">粉丝头条</h3>
            <p class="desc">
              日均亿级流量，精准数据赋能，将创作者博文精准推送给目标用户
            </p>
            <a
              href="https://weibo.com/u/3587960280"
              target="_blank"
              class="register-btn"
              @click="register"
            >
              免费咨询
            </a>
          </div>
        </div>
        <TopfansXingTai></TopfansXingTai>
        <TopfansScene></TopfansScene>
        <TopfansToufang></TopfansToufang>
        <TopfansBrightpoint></TopfansBrightpoint>
        <TopfansCase></TopfansCase>
        <TopfansContact></TopfansContact>
      </div>
    </div>
  </div>
</template>

<script>
import TopfansXingTai from './components/TopfansXingTai'
import TopfansScene from './components/TopfansScene'
import TopfansToufang from './components/TopfansToufang'
import TopfansBrightpoint from './components/TopfansBrightpoint'
import TopfansCase from './components/TopfansCase'
import TopfansContact from './components/TopfansContact'

export default {
  name: 'topfans_page',
  components: {
    TopfansXingTai,
    TopfansScene,
    TopfansToufang,
    TopfansBrightpoint,
    TopfansCase,
    TopfansContact
  },
  methods: {
    register() {
      const { contactInfo } = this.$refs
      document.documentElement.scrollTop = contactInfo.offsetTop - 40
    }
  }
}
</script>

<style lang="scss" scoped>
.topfans_page {
  .default-layout {
    min-height: 100vh;
    .main {
      flex: 1;
    }
  }
  .banner {
    background: url('~@/assets/img/topfans/banner-bg.png') no-repeat center /
      cover;
    height: 640px;
    position: relative;
    .content {
      position: absolute;
      top: 221px;
      left: 172px;
    }
    .title {
      color: $text-color-title;
      font-size: 30px;
      margin-bottom: 20px;
      padding-bottom: 20px;
      position: relative;
      &:after {
        content: '';
        background-color: $white;
        width: 24px;
        height: 4px;
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
    .desc {
      margin-bottom: 32px;
      font-size: 16px;
      color: rgba(255, 255, 255, 0.75);
    }
    .register-btn {
      background-color: $danger-color;
      cursor: pointer;
      text-align: center;
      width: 104px;
      height: 34px;
      line-height: 34px;
      border-radius: 17px;
      color: $white;
      display: inline-block;
      margin-right: 24px;
      font-size: 14px;
    }
  }
}
.contact-info {
  padding-top: 64px;
  padding-bottom: 88px;
  background-color: #f4f5f7;
  .sub-title {
    text-align: center;
    margin-bottom: 60px;
  }
}
</style>

<style lang="scss">
.topfans_page {
  .topfans-section {
    padding: 64px 0 88px;
    .title {
      padding-bottom: 20px;
      margin-bottom: 28px;
      position: relative;
      text-align: center;
      &:after {
        content: '';
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        width: 32px;
        height: 5px;
        background: $danger-color;
        border-radius: 2px;
      }
    }
    .subtitle {
      margin-top: 12px;
      text-align: center;
      font-size: 16px;
    }
  }
  .contact-info-component {
    .left {
      .submit-box {
        .submit {
          background-color: $danger-color;
        }
      }
    }
    .right {
      .tel {
        color: $danger-color;
      }
    }
  }
}
</style>
